// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { MainPage } from './pages/main/MainPage';
import { InvoicePage } from './pages/invoice/InvoicePage';
import { Header } from './header/Header';
import { ImageBackground } from './ImageBackground';
import { DownloadsFileView } from './pages/downloads/DownloadsFileView';

export const MainRouter = () => {
  return (
    <Router style={{width: '100%'}}>
      <Header />
      <Routes>
        <Route path="/" exact element={<MainPage />} />
        <Route path="/facturar/:id" element={<InvoicePage />} />
        <Route path="/facturar/descarga/:id" element={<DownloadsFileView />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ImageBackground />
    </Router>
  );
}
 
export default MainRouter;
